var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#3F3F45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.25035V3.75051C6.75 3.3364 6.41437 3.00065 6.00026 3.00051C5.58595 3.00036 5.25 3.33619 5.25 3.75051V8.25035C5.25 8.66456 5.58579 9.00035 6 9.00035C6.41421 9.00035 6.75 8.66456 6.75 8.25035Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 5.25024L3.75016 5.25024C3.33605 5.25024 3.0003 5.58587 3.00016 5.99998C3.00001 6.4143 3.33584 6.75024 3.75016 6.75024L8.25 6.75024C8.66421 6.75024 9 6.41446 9 6.00024C9 5.58603 8.66421 5.25024 8.25 5.25024Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusOutline);
export default __webpack_public_path__ + "static/media/plus-outline.8a04e6e01c1d6be03b08c8d58a34c2f9.svg";
export { ForwardRef as ReactComponent };